export default function NotFound404() {
  return (
    <div>404 not found</div>
  )
}